var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell',{staticClass:"icon",class:{'is-framed': _vm.framed},attrs:{"border":_vm.border,"data-theme":_vm.theme,"align":_vm.align}},[_c('div',{staticClass:"icon-wrapper"},[_c('app-icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }